import {Message} from "element-ui";
import _request from "../common/_request";
import cache_activity from "../cache/cache_activity";


let lib_city = {

    //城市
    list: function (city, callback) {
        let data = {};
        data.city = city;
        _request._get('/city/list', data, function (response) {
            if (response.code !== _request.success) {
                Message.info(response.msg);
                return;
            }
            //回调数据
            if (typeof callback === 'function') {
                callback(response.data)
            }
        })
    },
    //城市 之家
    listx: function (city, callback) {
        let data = {};
        data.city = city;
        _request._get('/city/listx', data, function (response) {
            if (response.code !== _request.success) {
                Message.info(response.msg);
                return;
            }
            //回调数据
            if (typeof callback === 'function') {
                callback(response.data)
            }
        })
    },

    //皓博经销商城市
    atb: function ( callback) {
        let data = {};
        // data.city = city;
        _request._get('/city/atb', data, function (response) {
            if (response.code !== _request.success) {
                Message.info(response.msg);
                return;
            }
            //回调数据
            if (typeof callback === 'function') {
                callback(response.data)
            }
        })
    },

};
export default lib_city
